import React, { useState } from 'react';
import { supabase } from '../lib/supabase.js';

const S = {
  page: { minHeight: '100vh', backgroundColor: '#0d1b0f', backgroundImage: 'radial-gradient(ellipse at 50% 30%, rgba(45,106,79,0.4) 0%, transparent 60%)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '2rem', fontFamily: "'Lato', sans-serif" },
  card: { background: 'rgba(0,0,0,0.4)', border: '1px solid rgba(201,168,76,0.3)', borderRadius: '8px', padding: '2.5rem', width: '100%', maxWidth: '380px', display: 'flex', flexDirection: 'column', gap: '1.25rem' },
  title: { fontFamily: "'Playfair Display', serif", color: '#c9a84c', fontSize: '1.75rem', fontWeight: '700', letterSpacing: '0.2em', textTransform: 'uppercase', margin: 0, textAlign: 'center' },
  subtitle: { color: 'rgba(245,230,200,0.5)', fontSize: '0.75rem', letterSpacing: '0.1em', textTransform: 'uppercase', textAlign: 'center', margin: 0 },
  input: { background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(201,168,76,0.3)', borderRadius: '2px', padding: '0.85rem 1rem', color: '#f5e6c8', fontSize: '0.9rem', fontFamily: "'Lato', sans-serif", width: '100%', boxSizing: 'border-box', outline: 'none' },
  btn: { background: 'linear-gradient(135deg, #c9a84c, #f0c040)', color: '#0d1b0f', border: 'none', padding: '1rem', fontSize: '0.9rem', fontWeight: '700', fontFamily: "'Playfair Display', serif", letterSpacing: '0.15em', textTransform: 'uppercase', cursor: 'pointer', borderRadius: '2px', width: '100%' },
  btnOutline: { background: 'transparent', color: '#c9a84c', border: '1px solid rgba(201,168,76,0.4)', padding: '0.85rem', fontSize: '0.85rem', fontFamily: "'Lato', sans-serif", letterSpacing: '0.1em', textTransform: 'uppercase', cursor: 'pointer', borderRadius: '2px', width: '100%' },
  error: { color: '#f87171', fontSize: '0.8rem', textAlign: 'center', letterSpacing: '0.05em' },
  success: { color: '#4ade80', fontSize: '0.8rem', textAlign: 'center', letterSpacing: '0.05em' },
  divider: { display: 'flex', alignItems: 'center', gap: '1rem' },
  dividerLine: { flex: 1, height: '1px', backgroundColor: 'rgba(201,168,76,0.2)' },
  dividerText: { color: 'rgba(201,168,76,0.4)', fontSize: '0.7rem', letterSpacing: '0.1em' },
  link: { color: '#c9a84c', fontSize: '0.8rem', textAlign: 'center', cursor: 'pointer', letterSpacing: '0.05em', textDecoration: 'underline', background: 'none', border: 'none', fontFamily: "'Lato', sans-serif" },
};

export default function Login({ onBack, onSuccess, onGoToRegister }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleLogin() {
    if (!email || !password) { setError('Please enter your email and password'); return; }
    setLoading(true);
    setError('');
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) setError(error.message);
    else onSuccess();
    setLoading(false);
  }

  async function handleGuestPlay() {
    onSuccess(true);
  }

  return (
    <div style={S.page}>
      <div style={{ position: 'fixed', top: 0, left: 0, right: 0, height: '4px', background: 'linear-gradient(90deg, transparent, #c9a84c, #f0c040, #c9a84c, transparent)' }} />

      <div style={S.card}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '2.5rem', color: '#c9a84c', marginBottom: '0.5rem' }}>♠</div>
          <h1 style={S.title}>Sign In</h1>
          <p style={S.subtitle}>Welcome back to Pounce League</p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          <input
            style={S.input}
            type="email"
            placeholder="Email address"
            value={email}
            onChange={e => setEmail(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleLogin()}
          />
          <input
            style={S.input}
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleLogin()}
          />
        </div>

        {error && <p style={S.error}>{error}</p>}

        <button style={{ ...S.btn, opacity: loading ? 0.7 : 1 }} onClick={handleLogin} disabled={loading}>
          {loading ? 'Signing in...' : '♠ Sign In'}
        </button>

        <div style={S.divider}>
          <div style={S.dividerLine} />
          <span style={S.dividerText}>OR</span>
          <div style={S.dividerLine} />
        </div>

        <button style={S.btnOutline} onClick={handleGuestPlay}>
          Play as Guest
        </button>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', alignItems: 'center' }}>
          <button style={S.link} onClick={onGoToRegister}>
            Don't have an account? Create one
          </button>
          <button style={{ ...S.link, color: 'rgba(245,230,200,0.4)', textDecoration: 'none' }} onClick={onBack}>
            ← Back to Main Menu
          </button>
        </div>
      </div>

      <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, height: '4px', background: 'linear-gradient(90deg, transparent, #c9a84c, #f0c040, #c9a84c, transparent)' }} />
    </div>
  );
}
